import { setBroadcast } from 'actions/Broadcast';

function limitedBroadcastUpdated({ dispatch }, payload) {
  dispatch(setBroadcast(payload));
}

export default limitedBroadcastUpdated;
